export const MAX_CHARACTER_LIMIT = 10000;

export const DEFAULT_MAX_CHARACTER_EXCERPT = 90;
export const EXCERPT_SUFFIX = '...';

const JPEG = 'image/jpeg';
const JPG = 'image/jpg';
const PNG = 'image/png';

export const ACCEPTED_FILES = `${JPEG},${JPG},${PNG}`;
export const ACCEPTED_VIDEO_FILES = `video/mp4, video/x-m4v, video/*`;
export const MAX_IMAGE_SIZE = 10; // MB
export const MAX_VIDEO_SIZE = 5000; // MB
